import frMessages from '../locales/fr_FR';

const FrLang = {
  messages: {
    ...frMessages
  },
  locale: 'fr-FR'
};
export default FrLang;
